{
  "fr": {
    "collections": {
      "headings": {
        "courses": "Formations adaptées",
        "gradeLevels": "Niveaux scolaires",
        "materials": "Matériels",
        "schoolTypes": "Types d'écoles",
        "subjectTypes": "Matières scolaires"
      },
      "howTo": {
        "header": {
          "heading": "Les collections - découvrez des matériels pédagogiques prêts à l'emploi",
          "link": "Découvrir toutes les collections",
          "list_html": "<li><i class='bi bi-check-lg'></i>Les collections sont des ensembles de matériels pédagogiques sélectionnés pour des thèmes et des publics spécifiques.</li><li><i class='bi bi-check-lg'></i>Trouvez des plans de cours complets avec tous les matériaux, ou choisissez des éléments individuels et adaptez-les à vos besoins.</li><li><i class='bi bi-check-lg'></i>Avec le bouton Remix, créez rapidement une copie personnelle dans votre propre espace de stockage et utilisez-la directement en classe.</li>"
        },
        "recommendations": {
          "heading": "Découvrez les collections actuelles"
        },
        "tile": {
          "collectionTitle": "Heures de remplacement pour un apprentissage actif",
          "help": {
            "author_partner": "Auteur·e ou partenaire",
            "title": "Thème de la collection"
          },
          "staticAlt": "Enfants jouant au ballon dans la nature"
        },
        "title": "Tout savoir sur les collections"
      },
      "labels": {
        "fobizzTeam": "L'équipe fobizz"
      },
      "links": {
        "breadCrumbIndex": "Matériel pédagogique",
        "email": "E-mail",
        "learnMore": "En savoir plus"
      },
      "modelName": "Collection",
      "correctionAssistantHint": "L'IA peut aider les enseignants à analyser les travaux des élèves et à formuler des commentaires. Les contenus générés sont des suggestions qui doivent toujours être vérifiées. L'évaluation pédagogique est toujours effectuée par l'enseignant. Plus d'informations <a href='https://app.fobizz.com/website/public_pages/63f40923-707c-4c29-a3fb-24190cbaccd4?public_token=5661a251e6152bb6cc51ff14facde3d4&back_url=https%3A%2F%2Fapp.fobizz.com%2Fcollections%2Fb7294bbe-a1df-4a10-9031-89fc64cd1766&back_title=Vorlagen%20f%C3%BCr%20Korrekturhilfe%20und%20SuS-Feedback%20Assistenten' target='_blank'>ici</a>.",
      "searchPlaceholder": "Rechercher du matériel",
      "share": {
        "email": {
          "body": "Dans la galerie fobizz, j'ai trouvé \"{name}\" et je souhaite le partager avec vous. Vous pouvez y accéder via le lien suivant : {shareUrl}"
        }
      }
    }
  }
}
